//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class WebhookLogSearchOptions extends ItemBase {
    IDs: string[] = [];
    SearchText: string | null = null;
    WebhookIDs: string[] = [];
    StatusCodes: number[] = [];
    MinCreatedDate: string | null = null;
    MaxCreatedDate: string | null = null;
    LiveMode: boolean | null = null;

    constructor(initializer?: Partial<WebhookLogSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebhookLogSearchOptions";
}
